import React from "react";
import { useAuth } from "@/App";
import {
  LandingNav,
  HeroSection,
  StatsBar,
  TransportModes,
  HowItWorks,
  LocalDeliveryCTA,
  PartnerCTA,
  EnterpriseCTA,
  LandingFooter
} from "@/components/landing";

export default function LandingPage() {
  const { user } = useAuth();

  return (
    <div className="min-h-screen bg-background">
      {/* Navigation */}
      <LandingNav user={user} />

      {/* Hero Section */}
      <HeroSection user={user} />

      {/* Stats Bar */}
      <StatsBar />

      {/* Transport Modes */}
      <TransportModes />

      {/* How It Works */}
      <HowItWorks />

      {/* Local Delivery CTA */}
      <LocalDeliveryCTA />

      {/* Enterprise CTA */}
      <EnterpriseCTA />

      {/* Partner CTA */}
      <PartnerCTA />

      {/* Footer */}
      <LandingFooter />
    </div>
  );
}
